// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.streams-drawer-content {
  height: 100%;
}
.streams-drawer-content .content-grids-wrapper {
  transition: all 0.1s cubic-bezier(0.215, 0.61, 0.355, 1);
  height: 100%;
}
.streams-drawer-content .content-grids-wrapper.streams-content-grid {
  display: grid;
  grid-gap: 16px;
  grid-template-columns: repeat(auto-fit, 232px);
}
.streams-drawer-content streams-drawer-moderation-list {
  display: block;
  height: 100%;
}
`, "",{"version":3,"sources":["webpack://./app/streams-drawer/streams-drawer-content/streams-drawer-content.less"],"names":[],"mappings":"AAMA;EACE,YAAA;AALF;AAIA;EAII,wDAAA;EACA,YAAA;AALJ;AAOI;EACE,aAAA;EACA,cAAA;EACA,8CAAA;AALN;AALA;EAeI,cAAA;EACA,YAAA;AAPJ","sourcesContent":["//\n// Copyright (c) 2011-2018 by Curalate, Inc.\n//\n@import (reference) '../../../css/unison';\n@import (reference) '../../../lib/bootstrap-3.1.1/less/mixins';\n\n.streams-drawer-content {\n  height: 100%;\n\n  .content-grids-wrapper {\n    transition: all @cu-animation-length-short @cu-ease-out-cubic;\n    height: 100%;\n\n    &.streams-content-grid {\n      display: grid;\n      grid-gap: @cu-spacing-3;\n      grid-template-columns: repeat(auto-fit, @cu-small-measure);\n    }\n  }\n\n  streams-drawer-moderation-list {\n    display: block;\n    height: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
